export const APP_BASE_PATH = '/dashboard'

export const getAppBaseUrl = (): string => {
  if (typeof window === 'undefined') return ''
  return `${window.location.host}${APP_BASE_PATH}`
}
